import React from 'react';
import { BookOpen, ChevronLeft, ChevronRight, Feather, Heart, Sparkles } from 'lucide-react';

const PrayerGuideView = ({ guide, activeDay, setActiveDay }) => {
    if (!guide?.days?.length) {
        return <div className="guide-reader-empty">No prayer guide content is available.</div>;
    }

    const dayNumber = (day) => day.day ?? day.dayNumber;
    const activeIndex = Math.max(0, guide.days.findIndex((day) => dayNumber(day) === activeDay));
    const selectedDay = guide.days[activeIndex] || guide.days[0];
    const selectedDayNumber = dayNumber(selectedDay);

    return (
        <div className="guide-reader">
            <header className="guide-reader-hero">
                <div>
                    <p><Sparkles size={14} /> Your personalized path</p>
                    <h1>{guide.title || 'Personalized Prayer Guide'}</h1>
                    <span>{guide.days.length} days of scripture, reflection, and prayer</span>
                </div>
                <p>{guide.introduction}</p>
            </header>

            <nav className="guide-day-nav" aria-label="Prayer guide days">
                {guide.days.map((day) => (
                    <button
                        type="button"
                        key={dayNumber(day)}
                        className={dayNumber(day) === selectedDayNumber ? 'is-active' : ''}
                        onClick={() => setActiveDay(dayNumber(day))}
                    >
                        <span>{String(dayNumber(day)).padStart(2, '0')}</span>
                        <strong>{day.theme}</strong>
                    </button>
                ))}
            </nav>

            <article className="guide-day-reading">
                <header>
                    <div>
                        <p>Day {selectedDayNumber} of {guide.days.length}</p>
                        <h2>{selectedDay.theme}</h2>
                    </div>
                    <span>{String(selectedDayNumber).padStart(2, '0')}</span>
                </header>

                <section className="guide-day-scripture">
                    <p><BookOpen size={17} /> Read</p>
                    <blockquote>{selectedDay.scripture}</blockquote>
                </section>

                <section className="guide-day-reflection">
                    <p><Feather size={17} /> Reflect</p>
                    <div>{selectedDay.reflection}</div>
                </section>

                <section className="guide-day-prayer">
                    <p><Heart size={17} /> Pray</p>
                    <div>{selectedDay.prayer}</div>
                    <span>Amen.</span>
                </section>

                <footer>
                    <button
                        type="button"
                        disabled={activeIndex === 0}
                        onClick={() => setActiveDay(dayNumber(guide.days[activeIndex - 1]))}
                    >
                        <ChevronLeft size={17} /> Previous day
                    </button>
                    <span>{activeIndex + 1} / {guide.days.length}</span>
                    <button
                        type="button"
                        disabled={activeIndex === guide.days.length - 1}
                        onClick={() => setActiveDay(dayNumber(guide.days[activeIndex + 1]))}
                    >
                        Next day <ChevronRight size={17} />
                    </button>
                </footer>
            </article>
        </div>
    );
};

export default PrayerGuideView;
